export const PDF_PAGE_NUMBER_STYLES = Object.freeze({
  STANDARD: "standard",
  COMPACT: "compact",
  SIMPLE: "simple",
  MINIMAL: "minimal",
});

export const PDF_PAGE_NUMBER_STYLE_OPTIONS = Object.freeze([
  {
    value: PDF_PAGE_NUMBER_STYLES.STANDARD,
    label: "Standard",
    example: "Page 1 of 10",
  },
  {
    value: PDF_PAGE_NUMBER_STYLES.COMPACT,
    label: "Compact",
    example: "1 / 10",
  },
  {
    value: PDF_PAGE_NUMBER_STYLES.SIMPLE,
    label: "Simple",
    example: "Page 1",
  },
  {
    value: PDF_PAGE_NUMBER_STYLES.MINIMAL,
    label: "Minimal",
    example: "- 1 -",
  },
]);

export const DEFAULT_PDF_FOOTER_OPTIONS = Object.freeze({
  enabled: false,
  leftText: "",
  centerText: "Draft",
  rightText: "",
  includeContentPage: true,
  pageNumber: Object.freeze({
    enabled: false,
    position: "right",
    style: PDF_PAGE_NUMBER_STYLES.STANDARD,
  }),
});

export const DEFAULT_FULL_TAX_COMPUTATION_PDF_OPTIONS = Object.freeze({
  storePdf: false,
  footer: DEFAULT_PDF_FOOTER_OPTIONS,
});

const normalizeFooterText = (value) =>
  value == null ? "" : String(value).replace(/\s+/g, " ").trim();

export const normalizePdfFooterOptions = (footerOptions) => {
  const options =
    footerOptions && typeof footerOptions === "object" ? footerOptions : {};
  const pageNumber =
    options.pageNumber && typeof options.pageNumber === "object"
      ? options.pageNumber
      : {};
  const hasCenterText = Object.prototype.hasOwnProperty.call(
    options,
    "centerText",
  );
  const pageNumberPosition = ["left", "center", "right"].includes(
    pageNumber.position,
  )
    ? pageNumber.position
    : DEFAULT_PDF_FOOTER_OPTIONS.pageNumber.position;
  const pageNumberStyle = PDF_PAGE_NUMBER_STYLE_OPTIONS.some(
    (option) => option.value === pageNumber.style,
  )
    ? pageNumber.style
    : DEFAULT_PDF_FOOTER_OPTIONS.pageNumber.style;

  return {
    enabled: footerOptions === true || options.enabled === true,
    leftText: normalizeFooterText(options.leftText),
    centerText: hasCenterText
      ? normalizeFooterText(options.centerText)
      : DEFAULT_PDF_FOOTER_OPTIONS.centerText,
    rightText: normalizeFooterText(options.rightText),
    includeContentPage: options.includeContentPage !== false,
    pageNumber: {
      enabled: pageNumber.enabled === true,
      position: pageNumberPosition,
      style: pageNumberStyle,
    },
  };
};

export const normalizeFullTaxComputationPdfOptions = (pdfOptions) => {
  const options =
    pdfOptions && typeof pdfOptions === "object" ? pdfOptions : {};

  return {
    storePdf: options.storePdf === true,
    footer: normalizePdfFooterOptions(options.footer),
  };
};

export const areFullTaxComputationPdfOptionsEqual = (left, right) =>
  JSON.stringify(normalizeFullTaxComputationPdfOptions(left)) ===
  JSON.stringify(normalizeFullTaxComputationPdfOptions(right));

export const formatPdfPageNumber = ({ pageNumber, pageCount, style }) => {
  switch (style) {
    case PDF_PAGE_NUMBER_STYLES.COMPACT:
      return `${pageNumber} / ${pageCount}`;
    case PDF_PAGE_NUMBER_STYLES.SIMPLE:
      return `Page ${pageNumber}`;
    case PDF_PAGE_NUMBER_STYLES.MINIMAL:
      return `- ${pageNumber} -`;
    case PDF_PAGE_NUMBER_STYLES.STANDARD:
    default:
      return `Page ${pageNumber} of ${pageCount}`;
  }
};
